<div class="container-fluid dashboard__header">
    <div class="row">
        <div class="col-auto p-3">
            <img (click)="returnToDashboard();" style="max-height:40px;" class="img-fluid"
                src="../../../assets/Winning_Hands_Logo_Black-300x100.png">
        </div>
        <div class="col d-flex align-items-center">
        </div>
        <div class="col-4 p-3 align-items-center justify-content-end d-flex">
            <mat-icon class="mx-2" aria-hidden="false" aria-label="User Details" fontIcon="account_circle"></mat-icon>
            <mat-icon (click)="logoutUser();" class="mx-2" aria-hidden="false" aria-label="Log Out"
                fontIcon="logout"></mat-icon>
        </div>
    </div>
</div>
<div class="container-fluid admin-main-container">

    <div class="row">
        <div class="col-12 col-xs-12 col-sm-2 col-md-2 col-lg-1 col-xl-1 admin-menu position-fixed" >

          <div class="row">
            <div class="col-6 col-xs-6 col-sm-12 p-1 p-sm-3">
              <a (click)="goToEvents();" [class.admin-menu__link--active]="isEventsRoute"
                 class="admin-menu__link col-12 p-1 p-sm-3 d-flex align-items-center justify-content-center flex-column">

                <mat-icon>event</mat-icon>
                <p class="mb-0">Events</p>

              </a>
            </div>
            <div class="col-6 col-xs-6 col-sm-12 p-1 p-sm-3">
              <a (click)="goToTherapists();" [class.admin-menu__link--active]="isTherapistsRoute"
                 class="admin-menu__link col-12 p-1 p-sm-3 d-flex align-items-center justify-content-center flex-column">

                <mat-icon>group</mat-icon>
                <p class="mb-0">Therapists</p>

              </a>
            </div>
          </div>

        </div>
        <div class="col-12 col-xs-12 col-sm-10 col-md-10 col-lg-11 col-xl-11 offset-0 offset-xs-0 offset-sm-2 offset-md-2 offset-lg-1 offset-xl-1 px-4">
            <router-outlet></router-outlet>
        </div>
    </div>



</div>
